import { actionTypes } from "../actions/MlLicFormActions";
import { FilterOperatorTypes, SortTypes} from "../../util/table-view/TableTypes";
import { defaultResultsPerPage, pagingTotalRelation } from "../Types";

const initialState = {
  items: [],
  totalItems: 0,
  totalRelation: pagingTotalRelation.EQUALS,
  selectedItem: {},
  selectedItems: [],
  loading: false,
  loadingMore: false,
  posting: { busy: false, message: "", errors: null },
  validating:{busy: false},
  editing: null,
  noMore: true,
  recent: { busy: false, message: "", errors: null },
  recentList: null,
  masterLookupQuery: {
    order: SortTypes.desc,
    orderBy: "updatedAt",
    page: 0,
    size: 10,
    q: "",
    filters: [
      { operator: FilterOperatorTypes.equals, value: [true], field: "master" }
    ],
  },
  recentQuery: {
    order: SortTypes.desc,
    orderBy: "updatedAt",
    page: 0,
    size: 3,
    q: "",
    filters: [],
  },
  query: {
    order: SortTypes.desc,
    orderBy: "updatedAt",
    page: 0,
    size: defaultResultsPerPage,
    q: "",
    filters: [
      // { operator: FilterOperatorTypes.equals, value: [0], field: "status" },
    ],
  },
  copyTrackSearch: {
    items: [],
    totalItems: 0,
    totalRelation: pagingTotalRelation.EQUALS,
    selectedItem: {},
    selectedItems: [],
    loading: false,
    loadingMore: false,
    posting: { busy: false, message: "", errors: null },
    validating:{busy: false},
    errors: null,
    noMore: true,
    query:{
      order: SortTypes.desc,
      orderBy: "updatedAt",
      page: 0,
      size: defaultResultsPerPage,
      q: "",
      filters: [],
    }
  },
  copySelectedTrackSearch: {
    items: [],
    totalItems: 0,
    totalRelation: pagingTotalRelation.EQUALS,
    selectedItem: {},
    selectedItems: [],
    loading: false,
    loadingMore: false,
    posting: { busy: false, message: "", errors: null },
    validating:{busy: false},
    errors: null,
    noMore: true,
    query:{
      order: SortTypes.desc,
      orderBy: "updatedAt",
      page: 0,
      size: defaultResultsPerPage,
      q: "",
      filters: [],
    }
  },
  errors: null,
  lastRefreshed: 0,
  isAllocatedMenuOpen: false, 
  history:{}, 
  triggerFetchEpisodes: false,
};

export default function (state = initialState, action) {

  switch (action.type) {
    case actionTypes.LOADING:
      return {
        ...state,
        loading: true,
        loadingMore: false,
        errors: null,
        selectedItems: [],
        items: [],
      };
    case actionTypes.LOADING_COPY_TRACKS:
      return {
        ...state,
        copyTrackSearch: {
          ...state.copyTrackSearch, 
          loading: true,
          loadingMore: false,
          errors: null,
          selectedItems: [],
          items: [],
        }
      };
    case actionTypes.LOADING_COPY_SELECTED_TRACKS:
      return {
        ...state,
        copySelectedTrackSearch: {
          ...state.copySelectedTrackSearch, 
          loading: true,
          loadingMore: false,
          errors: null,
          selectedItems: [],
          items: [],
        }
      };

    case actionTypes.LOAD:
      return {
        ...state,
        loading: false,
        loadingMore: false,
        errors: null,
        items: action.payload,
        totalItems: action.total,
        totalRelation: action.totalRelation,
        selectedItem: action.payload[0] || {},
        selectedItems: [],
        noMore: false,
      };
    case actionTypes.LOAD_COPY_TRACKS:
      return {
        ...state,
        copyTrackSearch: {
          ...state.copyTrackSearch, 
          loading: false,
          loadingMore: false,
          errors: null,
          items: action.payload,
          totalItems: action.total,
          totalRelation: action.totalRelation,
          selectedItem: action.payload[0] || {},
          selectedItems: [],
          noMore: false,
        }
      };
    case actionTypes.LOAD_COPY_SELECTED_TRACKS:
      return {
        ...state,
        copySelectedTrackSearch: {
          ...state.copySelectedTrackSearch, 
          loading: false,
          loadingMore: false,
          errors: null,
          items: action.payload,
          totalItems: action.total,
          totalRelation: action.totalRelation,
          selectedItem: action.payload[0] || {},
          selectedItems: [],
          noMore: false,
        }
      };

    case actionTypes.ERROR:
      return {
        ...state,
        loading: false,
        loadingMore: false,
        errors: action.payload,
        items: [],
        totalItems: 0,
        totalRelation: pagingTotalRelation.EQUALS,
        noMore: true,
      };

      case actionTypes.CLEAR_ERRORS:
        return {
          ...state,
          posting: {
            // errors: null,
            // errors: action.payload,
            errors: action.payload ? action.payload : null,
          },
        };

    case actionTypes.LOAD_HISTORY:
      state.history[action.payload.cfId] = action.payload.history
      return {
        ...state
      };
      
    case actionTypes.REMOVE_HISTORY:
      delete state.history[action.payload];
      return {
        ...state
      };

    case actionTypes.SELECT_ITEMS:
      return {
        ...state,
        selectedItems: action.payload,
      };
    case actionTypes.COPY_TRACK_SELECT_ITEMS:
      return {
        ...state,
        copyTrackSearch: {
          ...state.copyTrackSearch, 
          selectedItems: action.payload,
        },
      };
    case actionTypes.COPY_SELECTED_TRACK_SELECT_ITEMS:
      return {
        ...state,
        copySelectedTrackSearch: {
          ...state.copySelectedTrackSearch, 
          selectedItems: action.payload,
        },
      };
    case actionTypes.QUERY:
      return {
        ...state,
        query: action.payload,
      };
    case actionTypes.COPY_TRACK_QUERY:
      return {
        ...state,
        copyTrackSearch: {
          ...state.copyTrackSearch, 
          query: action.payload
        },
      };
    case actionTypes.COPY_SELECTED_TRACK_QUERY:
      return {
        ...state,
        copySelectedTrackSearch: {
          ...state.copySelectedTrackSearch, 
          query: action.payload
        },
      };
    case actionTypes.FOCUS_ITEM:
      return {
        ...state,
        selectedItem: action.payload,
      };
    case actionTypes.COPY_TRACK_FOCUS_ITEM:
      return {
        ...state,
        copyTrackSearch: {
          ...state.copyTrackSearch, 
          selectedItem: action.payload,
        },
      };
    case actionTypes.COPY_SELECTED_TRACK_FOCUS_ITEM:
      return {
        ...state,
        copySelectedTrackSearch: {
          ...state.copySelectedTrackSearch, 
          selectedItem: action.payload,
        },
      };

    case actionTypes.EDIT_ITEM:
      return {
        ...state,
        editing: action.payload,
      };

    case actionTypes.POSTING:
      return {
        ...state,
        posting: {
          busy: true,
          message: action.payload,
          errors: null,
        },
      };

    case actionTypes.POST_OK:
      return {
        ...state,
        posting: {
          busy: false,
          message: "",
          errors: null,
        },
      };

    case actionTypes.POST_ERROR:
      return {
        ...state,
        posting: {
          busy: false,
          message: "",
          errors: action.payload,
        },
      };

    case actionTypes.VALIDATING:
      return {
        ...state,
        validating:{busy: true, },
        posting: {
          // busy: true,
          ...state.posting,
          message: action.payload,
          errors: state.posting?.errors ?? null,
        },
      };

    case actionTypes.VALIDATING_OK:
      return {
        ...state,
        validating:{busy: false, },
        posting: {
          // busy: false,
          ...state.posting,
          message: "",
          errors: state.posting?.errors ?? null,
        },
      };

    case actionTypes.VALIDATING_ERROR:
      return {
        ...state,
        validating:{busy: false, },
        posting: {
          // busy: false,
          ...state.posting,
          message: "",
          errors: state.posting?.errors ? {...state.posting.errors, ...action.payload} : action.payload,
        },
      };

    case actionTypes.RECENT_QUERY:
      return {
        ...state,
        recentQuery: { ...state.recentQuery, q: action.payload },
      };

    case actionTypes.RECENT_LOADING:
      return {
        ...state,
        recent: { busy: true, message: "", errors: null },
      };

    case actionTypes.RECENT_LOAD:
      return {
        ...state,
        recent: { busy: false, message: "", errors: null },
        recentList: action.payload,
      };
    case actionTypes.RECENT_ERROR:
      return {
        ...state,
        recent: { busy: false, message: "", errors: action.payload },
        recentList: [],
      };
    case actionTypes.REFRESH_ITEMS:
      return {
        ...state,
        items: action.payload,
      };

    case actionTypes.LAST_REFRESH:
      return {
        ...state,
        lastRefreshed: action.payload,
      };

      case actionTypes.IS_ALLOCATED_OPEN:
      return {
        ...state,
        isAllocatedMenuOpen: action.payload,
      };

      case actionTypes.CF_Share:
      return {
        ...state,
        posting: {
          busy: true,
          message: action.payload,
          errors: null,
        },
      };

      case actionTypes.CF_Share_OK:
        return {
          ...state,
          posting: {
            busy: false,
            message: "",
            errors: null,
          },
        };
      case actionTypes.RESET:
        return initialState;
      case actionTypes.COPY_TRACK_RESET:
        return {
          ...state,
          copyTrackSearch: {
            ...initialState.copyTrackSearch, 
          }
        };
      case actionTypes.COPY_SELECTED_TRACK_RESET:
        return {
          ...state,
          copySelectedTrackSearch: {
            ...initialState.copySelectedTrackSearch, 
          }
        };
      case actionTypes.TRIGGER_FETCH_EPISODES:
        return {
          ...state,
          triggerFetchEpisodes : !state.triggerFetchEpisodes,
        };

    default:
      return state;
  }
}
